import axios from '../../common/axios';
import { store } from '../../redux/store';
import { setActiveOrganization, getMemberships } from '../../features/organization-context/api';
import { slice } from './slice';
import type { InvitePreview, AcceptInviteResult } from './types';

export const PENDING_INVITE_TOKEN_KEY = 'pendingOrgInviteToken';

export function loadInvitePreview(token: string) {
  return async () => {
    const { dispatch } = store;
    dispatch(slice.actions.startLoading());
    try {
      const { data } = await axios.get<InvitePreview>(`/organization/invitations/${token}`);
      dispatch(slice.actions.loadSuccess(data));
    } catch {
      dispatch(slice.actions.loadError('invitation.invalid'));
    }
  };
}

export function acceptInvite(token: string) {
  return async () => {
    const { dispatch } = store;
    dispatch(slice.actions.startAccepting());
    try {
      const { data } = await axios.post<AcceptInviteResult>(
        `/organization/invitations/${token}/accept`
      );
      dispatch(slice.actions.acceptSuccess(data));
    } catch (err: any) {
      const msg = err?.response?.data?.message ?? 'invitation.accept_error';
      dispatch(slice.actions.acceptError(msg));
    }
  };
}

export async function linkPendingInviteAfterAuth(): Promise<void> {
  const token = sessionStorage.getItem(PENDING_INVITE_TOKEN_KEY);
  if (!token) return;
  try {
    const { data } = await axios.post<AcceptInviteResult>(
      `/organization/invitations/${token}/accept`
    );
    sessionStorage.removeItem(PENDING_INVITE_TOKEN_KEY);
    store.dispatch(setActiveOrganization(data.organizationGuid));
    store.dispatch(getMemberships());
  } catch {
    // Leave the token in storage — the accept call needs an authenticated session,
    // which register() doesn't yet have (unverified accounts can't log in). The
    // subsequent login() call retries with a real session and clears it on success.
  }
}
